import * as _4 from 'lodash4';
import { ICourseGrupInfo } from '../components/smart_search/smart_catalog_search';
import { SmartSearchPlugins } from '../configuration/plugins/smart_search_plugins';
declare var HIP: any;
// TODO: remove this code after fix the ai-prefab-search sink to page-index-changed
interface IHipPagination extends HTMLElement {
  _dispatchEvent: (eventName: string, payload: { value: number }) => void;
  pageIndex: number;
}
declare var window: Window & ICustomHIP;
// TODO: remove this code after fix the ai-prefab-search sink to page-index-changed
interface ICustomHIP {
  HIP: {
    aop: {
      pointCut: (
        elementName: string,
        method: string,
        callback: (httpInvokeFn: () => void) => (this: IHipPagination, httpPayload: any) => Promise<any>
      ) => {};
    };
  };
}
export class HIPModifier {
  private rootRoute: string = 'my/planner/plan/default/smart_course_details';
  private rootState: string = 'my.planner.plan.default.smart_course_details';
  private smartSearchPlugins: SmartSearchPlugins;

  constructor(courseDetailsRoute: string, courseDetailsState: string, courseGroupInfo: ICourseGrupInfo) {
    this.rootRoute = courseDetailsRoute;
    this.rootState = courseDetailsState;
    this.smartSearchPlugins = new SmartSearchPlugins(courseGroupInfo);
  }
  /* tslint:disable:cyclomatic-complexity */
  /* tslint:disable:cognitive-complexity */
  invoke() {
    this.smartSearchPlugins.runMetadataFieldsPlugin();
    this.smartSearchPlugins.runMetadataColumnsPlugin();
    this.smartSearchPlugins.runMultiFormPlugin();
    this.smartSearchPlugins.runPlanToTermActionPlugin();
    // TODO: remove this code after fix the ai-prefab-search sink to page-index-changed
    ['goToPage', 'goToPrevious', 'goToNext', 'goToFirst', 'goToLast'].forEach((methodName) => {
      window.HIP.aop.pointCut('hi-pagination', methodName, (orginalMethod: () => void) => {
        return function (this: IHipPagination, methodArgs: unknown) {
          this._dispatchEvent('tap-ended', {
            value: this.pageIndex
          });
          return orginalMethod.call(this, methodArgs);
        };
      });
    });
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/configuration/sgd_metadata.ts